<div class="landscape_inner_border">
    My today balance: 
    <div class="highlight"> 
        +20,000 UGX
    </div>
</div>